import Hero from './Detail/Hero';
import SecondHero from './Job/SecondHero';
import Description from './Job/Description';
import ApplyJob from './Job/ApplyJob';
import List from './Detail/List';
import Items from './Items';

export { Hero, SecondHero, Description, ApplyJob, List, Items };